module.exports = __webpack_public_path__ + "img/WhatsAppQR.5f28bda6.png";